import {SET, DELETED, ADDED} from './actionTypes';
import update from "immutability-helper";

const initialState = [];

export const reducer = (state = initialState, action) => {
  switch (action.type) {

    case SET:
      return action.templates;

    case DELETED:
      return update(state, {
        $unset: [action.template.id]
      });

    case ADDED:
      return {
        ...state,
        [action.template.id]: action.template
      };

    default:
      return state;
  }
};